import { useState } from "react"
import styles from "./product-manager.module.css"

export default function ProductManager({ onClose, onAddProduct }) {
  const [formData, setFormData] = useState({
    name: "",
    details: "",
    price: "",
    image: "",
  })
  const [loading, setLoading] = useState(false)

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const handleImage = (e) => {
    const file = e.target.files[0];
    setFormData((prev) => ({
      ...prev,
      image: file,
    }))
  };

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    try {
      await onAddProduct({
        ...formData,
        price: Number.parseInt(formData.price),
      })
      onClose()
    } catch (error) {
      console.error("Error adding product:", error)
      // Error handling is done in the parent component via toast
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h2>Add New Product</h2>
          <button className={styles.closeBtn} onClick={onClose}>
            ✕
          </button>
        </div>

        <form onSubmit={handleSubmit} className={styles.form}>
          <div className={styles.formGrid}>
            <div className={styles.formGroup}>
              <label>Product Name *</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                required
                placeholder="e.g., Valorant Points 1000"
              />
            </div>

            <div className={styles.formGroup}>
              <label>Price (₹) *</label>
              <input
                type="number"
                name="price"
                value={formData.price}
                onChange={handleInputChange}
                required
                placeholder="999"
              />
            </div>

            <div className={styles.formGroup}>
              <label>Details *</label>
              <textarea
                name="details"
                value={formData.details}
                onChange={handleInputChange}
                required
                placeholder="Product detail"
                rows="3"
              />
            </div>

            <div className={styles.formGroup}>
              <label>Product Image *</label>

              <label className={styles.fileUpload}>
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) =>
                    handleImage(e)
                  }
                  required
                />
                <span>{formData.image ? formData.image.name : "Choose an image(Max 5MB)..."}</span>
              </label>
            </div>
          </div>

          <div className={styles.formActions}>
            <button type="button" className={styles.cancelBtn} onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className={styles.submitBtn}>
              {loading ? "Adding..." : "Add Product"}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}
